
// import React, { useEffect, useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import ProductModal from '../Modal/ProductModal';
// import ProductQuickViewModal from '../Modal/ViewModal';
// import axios from 'axios';



// const BestSelling = () => {
//   const [hoveredProduct, setHoveredProduct] = useState(null);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [showModal2, setShowModal2] = useState(false);
//   // const [products, setProducts] = useState([]);

//   // useEffect(() => {
//   //   axios
//   //     .get("https://vantara.datacubeglobal.com/api/products")
//   //     .then((response) => {
//   //       if (response.data.status === "success") {
//   //         setProducts(response.data.data);
//   //       }
//   //     })
//   //     .catch((error) => console.error(error));
//   // }, []);

//   const products = [
//     {
//       id: 1,
//       images: [
//         "https://modavenextjs.vercel.app/images/products/womens/women-9.jpg",
//         "https://modavenextjs.vercel.app/images/products/womens/women-8.jpg"
//       ],
//       title: "Ribbed cotton-blend top",
//       price: "$39.99",
//     },
//     {
//       id: 2,
//       images: [
//         "https://modavenextjs.vercel.app/images/products/womens/women-172.jpg",
//         "https://modavenextjs.vercel.app/images/products/womens/women-172.jpg"
//       ],
//       title: "Faux-leather trousers",
//       price: "$79.99",
//     },
//     {
//       id: 3,
//       images: [
//         "https://modavenextjs.vercel.app/images/products/womens/women-84.jpg",
//         "https://modavenextjs.vercel.app/images/products/womens/women-83.jpg"
//       ],
//       title: "Belt wrap dress",
//       oldPrice: "$129.99",
//       price: "$98.00",
//       discount: "-25%",
//     },
//     {
//       id: 4,
//       images: [
//         "https://modavenextjs.vercel.app/images/products/womens/women-103.jpg",
//         "https://modavenextjs.vercel.app/images/products/womens/women-103.jpg"
//       ],
//       title: "Belt wrap dress",
//       oldPrice: "$129.99",
//       price: "$98.00",
//       discount: "-25%",
//     },
//   ];
//   useEffect(() => {
//     if (showModal || showModal2) {
//       document.body.style.overflow = "hidden";
//       document.documentElement.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "";
//       document.documentElement.style.overflow = "";
//     }

//     return () => {
//       document.body.style.overflow = "";
//       document.documentElement.style.overflow = "";
//     };
//   }, [showModal2]);




//     const handleQuickAdd = productId => {
//     const product = products.find(p => p.id === productId);
//     if (product) {
//       setSelectedProduct(product);
//       setShowModal2(true);
//     }
//   };

//   const handleOpenQuickView = (product) => {
//     setSelectedProduct(product);
//     setShowModal(true);
//   };

//   return (
//     <div className="container-fluid px-3 px-md-5 my-5">
//       <h2 className="text-center mb-12 fw-bold">Best Selling</h2>
//       <p className="text-center text-muted mb-5 fs-5  " style={{ color: "#000000FF" }}>
//         Browse our Top Trending the hottest picks loved by all.
//       </p>
//       <div className="d-none d-md-block">
//         <div className="row">
//           {products.map((product) => (
//             <div key={product.id} className="col-md-6 col-lg-3 mb-4">
//               <div
//                 className="card border-0 h-100"
//                 onMouseEnter={() => setHoveredProduct(product.id)}
//                 onMouseLeave={() => setHoveredProduct(null)}
//               >
//                 <div className="position-relative overflow-hidden">
//                   {product.discount && (
//                     <span className="badge bg-danger position-absolute top-0 start-0 m-2">
//                       {product.discount}
//                     </span>
//                   )}
//                   <span
//                     className="position-absolute top-0 end-0 m-2"
//                     style={{ cursor: 'pointer', zIndex: 5 }}
//                     onClick={() => handleOpenQuickView(product)}
//                   >
//                     <i className="bi bi-eye fs-5" style={{ color: "#000", padding: "3px" }}></i>
//                   </span>

//                   <img
//                     src={product.images[0]}
//                     className="card-img-top"
//                     alt={product.title}
//                     style={{
//                       height: '450px',
//                       objectFit: 'cover',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       width: '100%',
//                       transition: 'opacity 0.5s ease',
//                       opacity: hoveredProduct === product.id ? 0 : 1
//                     }}
//                   />
//                   <img
//                     src={product.images[1]}
//                     className="card-img-top"
//                     alt={product.title}
//                     style={{
//                       height: '450px',
//                       objectFit: 'cover',
//                       transition: 'opacity 0.5s ease',
//                       opacity: hoveredProduct === product.id ? 1 : 0
//                     }}
//                   />
//                   <div
//                     className="position-absolute bottom-0 start-0 end-0 d-flex justify-content-center pb-3"
//                     style={{
//                       opacity: hoveredProduct === product.id ? 1 : 0,
//                       transform: hoveredProduct === product.id ? 'translateY(0)' : 'translateY(100%)',
//                       transition: 'all 0.3s ease',
//                       pointerEvents: hoveredProduct === product.id ? 'auto' : 'none'
//                     }}
//                   >
//                     <button
//                       className="btn w-100 fw-semibold"
//                       onClick={() => handleQuickAdd(product.id)}
//                       style={{
//                         backgroundColor: '#1d2124',
//                         color: '#fff',
//                         borderRadius: '50px',
//                         padding: '8px 24px',
//                         fontSize: '0.95rem'
//                       }}
//                     >
//                       QUICK ADD
//                     </button>
//                   </div>
//                 </div>

//                 <div className="card-body text-center">
//                   <h5 className="card-title">{product.title}</h5>
//                   <div className="d-flex justify-content-center align-items-center">
//                     {product.oldPrice && (
//                       <span className="text-muted text-decoration-line-through me-2">
//                         {product.oldPrice}
//                       </span>
//                     )}
//                     <span className="fw-bold text-dark">{product.price}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>


//       <div className="d-md-none">
//         <div className="d-flex overflow-auto pb-3" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
//           <style>
//             {`
//               .d-md-none::-webkit-scrollbar {
//                 display: none;
//               }
//             `}
//           </style>
//           {products.map((product) => (
//             <div
//               key={product.id}
//               className="flex-shrink-0 me-3"
//               style={{ width: '47%' }}
//               onTouchStart={() => setHoveredProduct(hoveredProduct === product.id ? null : product.id)}
//             >
//               <div className="card border-0 shadow-sm h-100">
//                 <div className="position-relative overflow-hidden">
//                   {product.discount && (
//                     <span className="badge bg-danger position-absolute top-0 start-0 m-2">
//                       {product.discount}
//                     </span>
//                   )}
//                   <span
//                     className="position-absolute top-0 end-0 m-2"
//                     style={{ cursor: 'pointer', zIndex: 5 }}
//                     onClick={() => handleOpenQuickView(product)}
//                   >
//                     <i className="bi bi-eye fs-5" style={{ color: "#000", padding: "3px" }}></i>
//                   </span>

//                   <img
//                     src={product.images[0]}
//                     className="card-img-top"
//                     alt={product.title}
//                     style={{
//                       height: '280px',
//                       objectFit: 'cover',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       width: '100%',
//                       transition: 'opacity 0.5s ease',
//                       opacity: hoveredProduct === product.id ? 0 : 1
//                     }}
//                   />
//                   <img
//                     src={product.images[1]}
//                     className="card-img-top"
//                     alt={product.title}
//                     style={{
//                       height: '280px',
//                       objectFit: 'cover',
//                       transition: 'opacity 0.5s ease',
//                       opacity: hoveredProduct === product.id ? 1 : 0
//                     }}
//                   />
//                   <div
//                     className="position-absolute bottom-0 start-0 end-0 d-flex justify-content-center pb-3"
//                   // style={{
//                   //   opacity: hoveredProduct === product.id ? 1 : 0,
//                   //   transform: hoveredProduct === product.id ? 'translateY(0)' : 'translateY(100%)',
//                   //   transition: 'all 0.3s ease',
//                   //   pointerEvents: hoveredProduct === product.id ? 'auto' : 'none'
//                   // }}
//                   >
//                     <button
//                       className="btn w-100 fw-semibold"
//                       onClick={() => handleQuickAdd(product.id)}
//                       style={{
//                         backgroundColor: '#1d2124',
//                         color: '#fff',
//                         borderRadius: '50px',
//                         padding: '8px 24px',
//                         fontSize: '0.95rem'
//                       }}
//                     >
//                       QUICK ADD
//                     </button>
//                   </div>
//                 </div>

//                 <div className="card-body text-center">
//                   <h6 className="card-title" style={{ fontSize: '14px' }}>{product.title}</h6>
//                   <div className="d-flex justify-content-center align-items-center">
//                     {product.oldPrice && (
//                       <span className="text-muted text-decoration-line-through me-2" style={{ fontSize: '12px' }}>
//                         {product.oldPrice}
//                       </span>
//                     )}
//                     <span className="fw-bold text-dark" style={{ fontSize: '14px' }}>{product.price}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//       <ProductModal
//         show={showModal2}
//         onHide={() => setShowModal2(false)}
//         product={selectedProduct}
//       />

//       <ProductQuickViewModal
//         show={showModal}
//         onHide={() => setShowModal(false)}
//         product={selectedProduct}
//       />
//     </div>
//   );
// };

// export default BestSelling;



// import React, { useEffect, useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import ProductModal from '../Modal/ProductModal';
// import ProductQuickViewModal from '../Modal/ViewModal';
// import axios from 'axios';

// const BestSelling = () => {
//   const [hoveredProduct, setHoveredProduct] = useState(null);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [showModal2, setShowModal2] = useState(false);
//   const [products, setProducts] = useState([]);


// useEffect(() => {
//   axios
//     .get("https://vantara.datacubeglobal.com/api/random_products")
//     .then((response) => {
//       if (response.data.status === "success") {
//         const mapped = response.data.data.map((p) => {
//           const mrp = parseFloat(p.mrp);
//           const specialPrice = parseFloat(p.special_price);

//           const showDiscount = specialPrice > 0 && specialPrice < mrp;

//           return {
//             id: p.product_id,
//             title: p.product_name,
//             price: `₹${specialPrice > 0 ? specialPrice.toFixed(2) : mrp.toFixed(2)}`,
//             oldPrice: showDiscount ? `₹${mrp.toFixed(2)}` : null,
//             discount: showDiscount ? `-${Math.round(((mrp - specialPrice) / mrp) * 100)}%` : null,
//             images: [
//               `https://vantara.datacubeglobal.com/vantara/storage/app/public/${p.primary_image}`,
//               `https://vantara.datacubeglobal.com/vantara/storage/app/public/${p.primary_image}`,
//             ],
//           };
//         });

//         setProducts(mapped);
//       }
//     })
//     .catch((error) => console.error("Error fetching random products:", error));
// }, []);

//   // ✅ Handle scroll lock when modal opens
//   useEffect(() => {
//     if (showModal || showModal2) {
//       document.body.style.overflow = "hidden";
//       document.documentElement.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "";
//       document.documentElement.style.overflow = "";
//     }

//     return () => {
//       document.body.style.overflow = "";
//       document.documentElement.style.overflow = "";
//     };
//   }, [showModal, showModal2]);

//   const handleQuickAdd = (productId) => {
//     const product = products.find((p) => p.id === productId);
//     if (product) {
//       setSelectedProduct(product);
//       setShowModal2(true);
//     }
//   };

//   const handleOpenQuickView = (product) => {
//     setSelectedProduct(product);
//     setShowModal(true);
//   };

//   return (
//     <div className="container-fluid px-3 px-md-5 my-5">
//       <h2 className="text-center mb-12 fw-bold">Best Selling</h2>
//       <p className="text-center text-muted mb-5 fs-5" style={{ color: "#000" }}>
//         Browse our Top Trending the hottest picks loved by all.
//       </p>

//       {/* Desktop view */}
//       <div className="d-none d-md-block">
//         <div className="row">
//           {products.map((product) => (
//             <div key={product.id} className="col-md-6 col-lg-3 mb-4">
//               <div
//                 className="card border-0 h-100"
//                 onMouseEnter={() => setHoveredProduct(product.id)}
//                 onMouseLeave={() => setHoveredProduct(null)}
//               >
//                 <div className="position-relative overflow-hidden">
//                   {/* {product.discount && (
//                     <span className="badge bg-danger position-absolute top-0 start-0 m-2">
//                       {product.discount}
//                     </span>
//                   )} */}
//                   <span
//                     className="position-absolute top-0 end-0 m-2"
//                     style={{ cursor: "pointer", zIndex: 5 }}
//                     onClick={() => handleOpenQuickView(product)}
//                   >
//                     <i className="bi bi-eye fs-5" style={{ color: "#000", padding: "3px" }}></i>
//                   </span>

//                   <img
//                     src={product.images[0]}
//                     className="card-img-top"
//                     alt={product.title}
//                     style={{
//                       height: "450px",
//                       objectFit: "cover",
//                       position: "absolute",
//                       top: 0,
//                       left: 0,
//                       width: "100%",
//                       transition: "opacity 0.5s ease",
//                       opacity: hoveredProduct === product.id ? 0 : 1,
//                     }}
//                   />
//                   <img
//                     src={product.images[1]}
//                     className="card-img-top"
//                     alt={product.title}
//                     style={{
//                       height: "450px",
//                       objectFit: "cover",
//                       transition: "opacity 0.5s ease",
//                       opacity: hoveredProduct === product.id ? 1 : 0,
//                     }}
//                   />

//                   <div
//                     className="position-absolute bottom-0 start-0 end-0 d-flex justify-content-center pb-3"
//                     style={{
//                       opacity: hoveredProduct === product.id ? 1 : 0,
//                       transform: hoveredProduct === product.id ? "translateY(0)" : "translateY(100%)",
//                       transition: "all 0.3s ease",
//                       pointerEvents: hoveredProduct === product.id ? "auto" : "none",
//                     }}
//                   >
//                     <button
//                       className="btn w-100 fw-semibold"
//                        onClick={() => handleQuickAdd(product.product_id)}
//                       style={{
//                         backgroundColor: "#073a09",
//                         color: "#fff",
//                         borderRadius: "50px",
//                         padding: "8px 24px",
//                         fontSize: "0.95rem",
//                       }}
//                     >
//                       QUICK ADD
//                     </button>
//                   </div>
//                 </div>

//                 <div className="card-body text-center">
//                   <h5 className="card-title">{product.title}</h5>
//                   <div className="d-flex justify-content-center align-items-center">
//                     {product.oldPrice && (
//                       <span className="text-muted text-decoration-line-through me-2">
//                         {product.oldPrice}
//                       </span>
//                     )}
//                     <span className="fw-bold " style={{color: "#7c0046" }}>{product.price}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Mobile view */}
//       <div className="d-md-none">
//         <div className="d-flex overflow-auto pb-3" style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}>
//           <style>{`.d-md-none::-webkit-scrollbar { display: none; }`}</style>
//           {products.map((product) => (
//             <div
//               key={product.id}
//               className="flex-shrink-0 me-3"
//               style={{ width: "47%" }}
//               onTouchStart={() => setHoveredProduct(hoveredProduct === product.id ? null : product.id)}
//             >
//               <div className="card border-0 shadow-sm h-100">
//                 <div className="position-relative overflow-hidden">
//                   {/* {product.discount && (
//                     <span className="badge bg-danger position-absolute top-0 start-0 m-2">
//                       {product.discount}
//                     </span>
//                   )} */}
//                   <span
//                     className="position-absolute top-0 end-0 m-2"
//                     style={{ cursor: "pointer", zIndex: 5 }}
//                     onClick={() => handleOpenQuickView(product)}
//                   >
//                     <i className="bi bi-eye fs-5" style={{ color: "#000", padding: "3px" }}></i>
//                   </span>

//                   <img
//                     src={product.images[0]}
//                     className="card-img-top"
//                     alt={product.title}
//                     style={{
//                       height: "280px",
//                       objectFit: "cover",
//                       position: "absolute",
//                       top: 0,
//                       left: 0,
//                       width: "100%",
//                       transition: "opacity 0.5s ease",
//                       opacity: hoveredProduct === product.id ? 0 : 1,
//                     }}
//                   />
//                   <img
//                     src={product.images[1]}
//                     className="card-img-top"
//                     alt={product.title}
//                     style={{
//                       height: "280px",
//                       objectFit: "cover",
//                       transition: "opacity 0.5s ease",
//                       opacity: hoveredProduct === product.id ? 1 : 0,
//                     }}
//                   />

//                   <div className="position-absolute bottom-0 start-0 end-0 d-flex justify-content-center pb-3">
//                     <button
//                       className="btn w-100 fw-semibold"
//                     onClick={() => handleQuickAdd(product.product_id)}
//                       style={{
//                          backgroundColor: "#073a09",
//                         color: "#fff",
//                         borderRadius: "50px",
//                         padding: "8px 24px",
//                         fontSize: "0.95rem",
//                       }}
//                     >
//                       QUICK ADD
//                     </button>
//                   </div>
//                 </div>

//                 <div className="card-body text-center">
//                   <h6 className="card-title" style={{ fontSize: "14px" }}>
//                     {product.title}
//                   </h6>
//                   <div className="d-flex justify-content-center align-items-center">
//                     {/* {product.oldPrice && (
//                       <span
//                         className="text-muted text-decoration-line-through me-2"
//                         style={{ fontSize: "12px" }}
//                       >
//                         {product.oldPrice}
//                       </span>
//                     )} */}
//                     <span className="fw-bold text-dark" style={{ fontSize: "14px", color: "#7c0046"  }}>
//                       {product.price}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <ProductModal show={showModal2} onHide={() => setShowModal2(false)} product={selectedProduct}  />
//       <ProductQuickViewModal show={showModal} onHide={() => setShowModal(false)}  product={selectedProduct} productId={selectedProduct?.id} />
//     </div>
//   );
// };

// export default BestSelling;



import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ProductModal from '../Modal/ProductModal';
import ProductQuickViewModal from '../Modal/ViewModal';
import axios from 'axios';

const BestSelling = () => {
  const [hoveredProduct, setHoveredProduct] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [products, setProducts] = useState([]);
  useEffect(() => {
    axios
      .get("https://vantara.datacubeglobal.com/api/top-selling")
      .then((response) => {
        if (response.data.status === "success") {
          const mapped = response.data.data.map((p) => {
            const product = p.product;
            const baseUrl = "https://vantara.datacubeglobal.com/storage/";

            const primaryImage =
              product.images?.find((img) => img.is_primary === 1)?.image_path ||
              product.images?.[0]?.image_path ||
              "";

            const imageUrl = primaryImage
              ? `${baseUrl}${primaryImage}`
              : "https://via.placeholder.com/450?text=No+Image";

            const mrp = parseFloat(product.mrp) || 0;
            const specialPrice = parseFloat(product.special_price) || 0;
            const finalPrice = specialPrice > 0 ? specialPrice : mrp;
            const showDiscount = specialPrice > 0 && specialPrice < mrp;

            return {
              id: product.encrypted_product_id,
              title: product.product_name,
              price: finalPrice,
              stock: product.stock,
              originalPrice: showDiscount ? mrp : null,
              discount: showDiscount
                ? Math.round(((mrp - specialPrice) / mrp) * 100)
                : null,
              images: [imageUrl],
              totalSold: p.total_sold,
            };
          });

          setProducts(mapped);
        }
      })
      .catch((error) => console.error("Error fetching products:", error));
  }, []);

  // Scroll lock for modals
  useEffect(() => {
    if (showModal || showModal2) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [showModal, showModal2]);

  const handleQuickAdd = (productId) => {
    const product = products.find((p) => p.id === productId);
    if (product) {
      setSelectedProduct(product);
      setShowModal2(true);
    }
  };

  const handleOpenQuickView = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  return (
    <div className="container-fluid px-3 px-md-5 my-5">
     <h2 className="text-center mb-4 fw-bold">Best Selling</h2>
       <p className="text-center text-muted mb-5 fs-5" style={{ color: "#000" }}>
        Browse our Top Trending the hottest picks loved by all.
      </p>

      {/* Desktop */}
      {/* <div className="d-none d-md-block">
        <div className="row">
          {products.map((product) => (
            <div key={product.id} className="col-md-6 col-lg-3 mb-4">
              <div
                className="card border-0 h-100"
                onMouseEnter={() => setHoveredProduct(product.id)}
                onMouseLeave={() => setHoveredProduct(null)}
              >
                <div className="position-relative overflow-hidden" style={{ height: "450px" }}>
                  <span
                    className="position-absolute top-0 end-0 m-2"
                    style={{ cursor: "pointer", zIndex: 5 }}
                    onClick={() => handleOpenQuickView(product)}
                  >
                    <i className="bi bi-eye fs-5" style={{ color: "#000", padding: "3px" }}></i>
                  </span>

                  <img
                    src={product.images[0]}
                    className="card-img-top"
                    alt={product.title}
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />


                  <div
                    className="position-absolute bottom-0 start-0 end-0 d-flex justify-content-center pb-3"
                    style={{
                      opacity: hoveredProduct === product.id ? 1 : 0,
                      transform: hoveredProduct === product.id ? "translateY(0)" : "translateY(100%)",
                      transition: "all 0.3s ease",
                      pointerEvents: hoveredProduct === product.id ? "auto" : "none",
                    }}
                  >
                    {product.stock === 0 ? (
                      <button
                        className="btn w-90 fw-semibold"
                        disabled
                        style={{
                          backgroundColor: "#6c757d",
                          color: "#fff",
                          borderRadius: "50px",
                          padding: "8px 24px",
                          fontSize: "0.95rem",
                          cursor: "not-allowed",
                        }}
                      >
                        OUT OF STOCK
                      </button>
                    ) : (
                      <button
                        className="btn w-90 fw-semibold"
                        onClick={() => handleQuickAdd(product.id)}
                        style={{
                          backgroundColor: "#073a09",
                          color: "#fff",
                          borderRadius: "50px",
                          padding: "8px 24px",
                          fontSize: "0.95rem",
                        }}
                      >
                        QUICK ADD
                      </button>
                    )}
                  </div>

                </div>

                <div className="card-body text-center">
                  <h5 className="card-title">{product.title}</h5>
                  <div className="d-flex justify-content-center align-items-center">
                    {product.originalPrice !== null && (
                      <span className="text-muted text-decoration-line-through me-2">
                        ₹{product.originalPrice.toFixed(2)}
                      </span>
                    )}
                    <span className="fw-bold" style={{ color: "#7c0046" }}>
                      ₹{product.price.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}
<div className="d-none d-md-block">
  <div className="row">
    {products.map((product) => (
      <div key={product.id} className="col-md-6 col-lg-3 mb-4">
        <div
          className="card border-0 h-100 shadow-sm"
          onMouseEnter={() => setHoveredProduct(product.id)}
          onMouseLeave={() => setHoveredProduct(null)}
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            transition: "transform 0.3s ease",
          }}
        >
          <div
            className="position-relative overflow-hidden"
            style={{
              height: "350px", // 👈 uniform image height
              borderRadius: "12px",
              backgroundColor: "#f8f8f8",
            }}
          >
            {/* Quick View Icon */}
            <span
              className="position-absolute top-0 end-0 m-2"
              style={{ cursor: "pointer", zIndex: 5 }}
              onClick={() => handleOpenQuickView(product)}
            >
              <i className="bi bi-eye fs-5" style={{ color: "#000", padding: "3px" }}></i>
            </span>

            {/* Product Image */}
            <img
              src={product.images[0]}
              className="card-img-top"
              alt={product.title}
              style={{
                height: "100%",
                width: "100%",
                objectFit: "cover",
                borderRadius: "12px",
                transition: "transform 0.4s ease",
                transform: hoveredProduct === product.id ? "scale(1.05)" : "scale(1)",
              }}
            />

            {/* Quick Add / Out of Stock Button */}
            <div
              className="position-absolute bottom-0 start-0 end-0 d-flex justify-content-center pb-3"
              style={{
                opacity: hoveredProduct === product.id ? 1 : 0,
                transform: hoveredProduct === product.id ? "translateY(0)" : "translateY(100%)",
                transition: "all 0.3s ease",
                pointerEvents: hoveredProduct === product.id ? "auto" : "none",
              }}
            >
              {product.stock === 0 ? (
                <button
                  className="btn fw-semibold"
                  disabled
                  style={{
                    backgroundColor: "#6c757d",
                    color: "#fff",
                    borderRadius: "50px",
                    padding: "8px 24px",
                    fontSize: "0.9rem",
                    cursor: "not-allowed",
                    width: "150px", // 👈 fixed width for uniformity
                  }}
                >
                  OUT OF STOCK
                </button>
              ) : (
                <button
                  className="btn fw-semibold"
                  onClick={() => handleQuickAdd(product.id)}
                  style={{
                    backgroundColor: "#073a09",
                    color: "#fff",
                    borderRadius: "50px",
                    padding: "8px 24px",
                    fontSize: "0.9rem",
                    width: "150px",
                    transition: "all 0.3s ease",
                  }}
                >
                  QUICK ADD
                </button>
              )}
            </div>
          </div>

          {/* Product Details */}
          <div className="card-body text-center">
            <h5 className="card-title text-truncate" style={{ fontSize: "1rem", fontWeight: "600" }}>
              {product.title}
            </h5>
            <div className="d-flex justify-content-center align-items-center">
              {product.originalPrice !== null && (
                <span className="text-muted text-decoration-line-through me-2">
                  ₹{product.originalPrice.toFixed(2)}
                </span>
              )}
              <span className="fw-bold" style={{ color: "#7c0046" }}>
                ₹{product.price.toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

      {/* Mobile */}
      {/* <div className="d-md-none">
        <div className="d-flex overflow-auto pb-3" style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}>
          <style>{`.d-md-none::-webkit-scrollbar { display: none; }`}</style>
          {products.map((product) => (
            <div
              key={product.id}
              className="flex-shrink-0 me-3"
              style={{ width: "47%" }}
              onClick={() => handleOpenQuickView(product)} // Optional: tap to view
            >
              <div className="card border-0 shadow-sm h-100">
                <div className="position-relative overflow-hidden" style={{ height: "280px" }}>
                  <span
                    className="position-absolute top-0 end-0 m-2"
                    style={{ cursor: "pointer", zIndex: 5 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenQuickView(product);
                    }}
                  >
                    <i className="bi bi-eye fs-5" style={{ color: "#000", padding: "3px" }}></i>
                  </span>

                  <img
                    src={product.images[0]}
                    className="card-img-top"
                    alt={product.title}
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                      position: "absolute",
                      top: 0,
                      left: 0,
                      opacity: hoveredProduct === product.id ? 0 : 1,
                    }}
                  />
                  <img
                    src={product.images[1]}
                    className="card-img-top"
                    alt={product.title}
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                      opacity: hoveredProduct === product.id ? 1 : 0,
                    }}
                  />


                  <div className="position-absolute bottom-0 start-0 end-0 d-flex justify-content-center pb-3">
                    {product.stock === 0 ? (
                      <button
                        className="btn w-90 fw-semibold"
                        disabled
                        style={{
                          backgroundColor: "#6c757d",
                          color: "#fff",
                          borderRadius: "50px",
                          padding: "8px 24px",
                          fontSize: "0.95rem",
                          cursor: "not-allowed",
                        }}
                      >
                        OUT OF STOCK
                      </button>
                    ) : (
                      <button
                        className="btn w-90 fw-semibold"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleQuickAdd(product.id);
                        }}
                        style={{
                          backgroundColor: "#073a09",
                          color: "#fff",
                          borderRadius: "50px",
                          padding: "8px 24px",
                          fontSize: "0.95rem",
                        }}
                      >
                        QUICK ADD
                      </button>
                    )}
                  </div>

                </div>

                <div className="card-body text-center">
                  <h6 className="card-title" style={{ fontSize: "14px" }}>
                    {product.title}
                  </h6>
                  <div className="d-flex justify-content-center align-items-center">
                    {product.originalPrice !== null && (
                      <span
                        className="text-muted text-decoration-line-through me-2"
                        style={{ fontSize: "12px" }}
                      >
                        ₹{product.originalPrice.toFixed(2)}
                      </span>
                    )}
                    <span className="fw-bold" style={{ fontSize: "14px", color: "#7c0046" }}>
                      ₹{product.price.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}
<div className="d-md-none">
  <div
    className="d-flex overflow-auto pb-3"
    style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
  >
    <style>{`
      .d-md-none::-webkit-scrollbar { display: none; }
    `}</style>

    {products.map((product) => (
      <div
        key={product.id}
        className="flex-shrink-0 me-3"
        style={{ width: "47%" }}
        onClick={() => handleOpenQuickView(product)}
      >
        <div
          className="card border-0 shadow-sm h-100"
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            transition: "transform 0.3s ease",
          }}
        >
          <div
            className="position-relative overflow-hidden"
            style={{
              height: "250px", // 👈 uniform image height for all cards
              borderRadius: "12px",
              backgroundColor: "#f8f8f8",
            }}
          >
            {/* Eye Icon */}
            <span
              className="position-absolute top-0 end-0 m-2"
              style={{ cursor: "pointer", zIndex: 5 }}
              onClick={(e) => {
                e.stopPropagation();
                handleOpenQuickView(product);
              }}
            >
              <i className="bi bi-eye fs-5" style={{ color: "#000", padding: "3px" }}></i>
            </span>

            {/* Product Image */}
            <img
              src={product.images[0]}
              alt={product.title}
              className="card-img-top"
              style={{
                height: "100%",
                width: "100%",
                objectFit: "cover",
                borderRadius: "12px",
                transition: "transform 0.4s ease",
              }}
            />

            {/* Quick Add / Out of Stock */}
            <div
              className="position-absolute bottom-0 start-0 end-0 d-flex justify-content-center pb-2"
              style={{
                opacity: 1, // always visible on mobile for easy tap
              }}
            >
              {product.stock === 0 ? (
                <button
                  className="btn fw-semibold"
                  disabled
                  style={{
                    backgroundColor: "#6c757d",
                    color: "#fff",
                    borderRadius: "50px",
                    padding: "6px 18px",
                    fontSize: "12px",
                    width: "130px",
                    cursor: "not-allowed",
                  }}
                >
                  OUT OF STOCK
                </button>
              ) : (
                <button
                  className="btn fw-semibold"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleQuickAdd(product.id);
                  }}
                  style={{
                    backgroundColor: "#073a09",
                    color: "#fff",
                    borderRadius: "50px",
                    padding: "6px 18px",
                    fontSize: "12px",
                    width: "130px",
                    transition: "all 0.3s ease",
                  }}
                >
                  QUICK ADD
                </button>
              )}
            </div>
          </div>

          {/* Product Info */}
          <div className="card-body text-center p-2">
            <h6
              className="card-title text-truncate"
              style={{ fontSize: "13px", fontWeight: "600", marginBottom: "4px" }}
            >
              {product.title}
            </h6>
            <div className="d-flex justify-content-center align-items-center">
              {product.originalPrice !== null && (
                <span
                  className="text-muted text-decoration-line-through me-2"
                  style={{ fontSize: "12px" }}
                >
                  ₹{product.originalPrice.toFixed(2)}
                </span>
              )}
              <span className="fw-bold" style={{ fontSize: "13px", color: "#7c0046" }}>
                ₹{product.price.toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

      {/* Modals - MUST be outside all other JSX, at the bottom */}
      <ProductModal
        show={showModal2}
        onHide={() => setShowModal2(false)}
        product={selectedProduct}
      />
      <ProductQuickViewModal
        show={showModal}
        onHide={() => setShowModal(false)}
        product={selectedProduct}
         productId={selectedProduct?.id}
      />
    </div>
  );
};

export default BestSelling;